import React, { useEffect } from 'react';
import { localizedValue } from '../../localization/presentationLanguage';

const styles = {
  backdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 1400,
    background: 'rgba(6,4,12,0.72)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 18,
  },

  modal: {
    width: '100%',
    maxWidth: 460,
    borderRadius: 28,
    border: '1px solid rgba(218,165,32,0.18)',
    background:
      'linear-gradient(180deg, rgba(24,12,40,0.98) 0%, rgba(10,7,20,0.99) 100%)',
    boxShadow: '0 28px 90px rgba(0,0,0,0.42)',
    overflow: 'hidden',
  },

  body: {
    padding: 22,
    display: 'grid',
    gap: 12,
  },

  eyebrow: {
    margin: 0,
    color: '#F7D774',
    fontSize: 11,
    fontWeight: 900,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },

  title: {
    margin: 0,
    color: '#FFF3C4',
    fontSize: 22,
    fontWeight: 900,
    lineHeight: 1.15,
  },

  text: {
    margin: 0,
    color: 'rgba(255,243,196,0.78)',
    fontSize: 14,
    lineHeight: 1.7,
  },

  actions: {
    display: 'flex',
    gap: 10,
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    marginTop: 8,
  },

  cancelButton: {
    minHeight: 44,
    padding: '0 16px',
    borderRadius: 999,
    border: '1px solid rgba(218,165,32,0.18)',
    background: 'rgba(255,255,255,0.04)',
    color: '#FFF3C4',
    fontSize: 13,
    fontWeight: 900,
    cursor: 'pointer',
  },

  confirmButton: {
    minHeight: 44,
    padding: '0 16px',
    borderRadius: 999,
    border: '1px solid rgba(255,120,120,0.22)',
    background: 'rgba(255,90,90,0.14)',
    color: '#FFD7D7',
    fontSize: 13,
    fontWeight: 900,
    cursor: 'pointer',
  },
};

export default function ConfirmModal({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm = () => {},
  onCancel = () => {},
}) {
  const resolvedTitle = title || localizedValue({ es: 'Confirmar acción', en: 'Confirm action' });
  const resolvedMessage = message || localizedValue({ es: '¿Querés continuar?', en: 'Would you like to continue?' });
  const resolvedConfirmLabel = confirmLabel || localizedValue({ es: 'Confirmar', en: 'Confirm' });
  const resolvedCancelLabel = cancelLabel || localizedValue({ es: 'Cancelar', en: 'Cancel' });
  useEffect(() => {
    function handleKey(e) {
      if (e.key === 'Escape') onCancel();
    }

    if (open) document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div style={styles.backdrop} onClick={onCancel}>
      <div
        style={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div style={styles.body}>
          <p style={styles.eyebrow}>{localizedValue({ es: '✦ Confirmación', en: '✦ Confirmation' })}</p>

          <h3 id="confirm-modal-title" style={styles.title}>{resolvedTitle}</h3>

          <p style={styles.text}>{resolvedMessage}</p>

          <div style={styles.actions}>
            <button
              type="button"
              style={styles.cancelButton}
              onClick={onCancel}
            >
              {resolvedCancelLabel}
            </button>

            <button
              type="button"
              style={styles.confirmButton}
              onClick={onConfirm}
            >
              {resolvedConfirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
